import { createFileRoute } from '@tanstack/react-router';

import Step1Account from 'component/view/Onboarding/Step1Account';

export const Route = createFileRoute('/n/_public/register')({
  component: Step1Account,
});
